import type { Money, MoneyRow } from './types';

export interface FinancialTrendDay {
  date: string;
  amount: Money;
  chartValue: number | null;
  transactions: number;
  known: number;
  observed: boolean;
}

export function buildFinancialTrend(rows: Array<MoneyRow & { date: string }>, startDate: string, endDate: string, currency: string): FinancialTrendDay[] {
  const start = Date.parse(`${startDate}T00:00:00Z`);
  const end = Date.parse(`${endDate}T00:00:00Z`);
  if (!Number.isFinite(start) || !Number.isFinite(end) || start > end || (end - start) / 86400000 >= 366) return [];
  const indexed = new Map(rows.filter(row => row.currency === currency).map(row => [row.date, row]));
  const result: FinancialTrendDay[] = [];
  for (let time = start; time <= end; time += 86400000) {
    const date = new Date(time).toISOString().slice(0, 10);
    const row = indexed.get(date);
    const amount = row ? row.grossCollections : '0';
    const value = amount === null ? null : Number(amount);
    result.push({ date, amount, chartValue: value !== null && Number.isFinite(value) ? value : null, transactions: row?.transactions || 0, known: row?.coverage.grossKnown || 0, observed: Boolean(row) });
  }
  return result;
}
